{
    "Profile_SecureMyOffer_AdditionalSellers.additionalSellers": "Additional Sellers",
    "Profile_SecureMyOffer_AdditionalSellers.description": "Add additional sellers involved in this property transaction. You can add up to 3 additional sellers.",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.newSeller": "New Seller",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.sellerDetails": "Seller Details",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.firstName": "First Name",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.lastName": "Last Name",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.email": "Email",
    "Profile_SecureMyOffer_AdditionalSellers_Seller.phone": "Phone"
}
